import FieldConfig from "../../proto/field-config";
import FieldString from "../string/string";
import FieldReadOnly_InlineEditable from "./render/inline-editable";
import FieldReadOnly_FormElement from "./render/form-element";
import {FieldFilterType} from "../../proto/types";


/*
base field when we need to show value only ...
... used by moment at least
 */

export default class FieldReadOnly extends FieldString {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Value";
        this.typeGroup          = null
        this.typeDescription    = "Read only value";

        this.filterType         = FieldFilterType.STRING;
        this.icon               = null

        this.isSearchable       = true;

        _.assign(this.renderComponents,{

            formElement         : FieldReadOnly_FormElement,
            inlineEditable      : FieldReadOnly_InlineEditable,

        })


    }

}
